<template>
	<div class="row works-content photoswipe-wrapper" :class="{touch: touchDevice}">
		<div class="col-full masonry-wrap">
			<div class="masonry">
				<template v-for="(video, key) in videosConfirmedSorted">
					<div v-bind="{'data-aos': (key%2 ? 'fade-left' : 'fade-right')}" class="masonry__brick">
						<div class="item-folio">
							<div class="item-folio__thumb">
								<div class="video-image-holder photoswipe-item">
									<a v-bind="{href: 'javascript: void(0);', title: video[1], style: 'background-image: url(' + video[6] + ');', 'data-type': 'video', 'data-video': '<div class=\'wrapper\'><div class=\'video-wrapper\'><iframe class=\'pswp__video\' style=\'width: 100%; height: 100%;\' src=\'https://www.youtube-nocookie.com/embed/' + SiteHelper.youtubeId(video[4]) + '?rel=0\' frameborder=\'0\' allowfullscreen></iframe></div></div>'}" class="thumb-link" v-if="video[6]">
										<img v-bind="{src: video[6], srcset: video[6] + ' 1x, ' + video[6] + ' 2x', alt: video[1]}">
									</a>
									<a v-bind="{href: 'javascript: void(0);', title: video[1], style: 'background-image: url(' + video[5] + ');', 'data-type': 'video', 'data-video': '<div class=\'wrapper\'><div class=\'video-wrapper\'><iframe class=\'pswp__video\' style=\'width: 100%; height: 100%;\' src=\'https://www.youtube-nocookie.com/embed/' + SiteHelper.youtubeId(video[4]) + '?rel=0\' frameborder=\'0\' allowfullscreen></iframe></div></div>'}" class="thumb-link" v-else>
										<img v-bind="{src: video[5], srcset: video[5] + ' 1x, ' + video[5] + ' 2x', alt: video[1]}">
									</a>
								</div>
							</div>

							<div class="item-folio__text">
								<h3 class="item-folio__title" v-html="video[1]"></h3>
								<p class="item-folio__cat" v-if="video[3]"><a :href="video[3]" :title="video[2]">{{ video[2] }}</a></p>
								<p class="item-folio__cat" v-else>{{ video[2] }}</p>
							</div>

							<div class="item-folio__caption">
								<p>description</p>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	// import objects
	import {Helper as SiteHelper} from '../../assets/js/common.classes';
	import {Init as SiteInit} from '../../assets/js/common.classes';
	import {params} from '../../params';

	// export
	export default {
		name: 'WidgetVideos',
		data: function () {
			return {
				// videos arrays
				videos: params['videos'],
				videosConfirmed: [],
				touchDevice: false,

				// site helper object
				SiteHelper: SiteHelper,
				SiteInit: SiteInit
			}
		},
		methods: {
			imageLoadError () {
				console.log('Image failed to load');
			}
		},
		created: function () {
			// detect if this is touch device
			if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || (('undefined' !== typeof hash && hash['touch'] && hash['touch'].offsetTop) === 9)) {
				this.touchDevice = true;
			}

			// detect if array exists and is not empty
			let videoId, videoItem, imageBig, imageMedium, promiseBig, promiseMedium;
			if ('undefined' !== typeof this.videos && this.videos !== null && this.videos.length !== null && this.videos.length > 0) {
				// loop through videos array and push url for hq-quality and maxres video previews to array items
				const _this = this;
				_this.videos.forEach(function (item) {
					// video id
					videoId = _this.SiteHelper.youtubeId(item[4]);
					if (null === videoId) {return;}

					// get url for images
					imageBig = 'https://i1.ytimg.com/vi/' + videoId + '/maxresdefault.jpg';
					imageMedium = 'https://i1.ytimg.com/vi/' + videoId + '/hqdefault.jpg';

					// detect if medium image exists
					promiseMedium = $.getJSON('https://stats.wogames.info/json/url-exists.json', {url: imageMedium})
						.fail(function(jqxhr, textStatus, error) {
							console.warn('Failed to check if the image ' + imageMedium + ' exists (' + textStatus + ', ' + error + ').');
						});

					// detect if big image exists
					promiseBig = $.getJSON('https://stats.wogames.info/json/url-exists.json', {url: imageBig})
						.fail(function(jqxhr, textStatus, error) {
							console.warn('Failed to check if the image ' + imageBig + ' exists (' + textStatus + ', ' + error + ').');
						});

					// when both requests complete
					$.when(promiseMedium, promiseBig).then(function (dataMedium, dataBig) {
						// detect if medium image exists
						if (true === dataMedium[0]['ok']) {
							// generate video item array
							videoItem = [
								item[0], // number
								item[1], // title
								item[2], // author
								item[3], // channel url
								item[4], // video url
								dataMedium[0]['url'] // medium image
							];

							// detect if big image exists
							if (true === dataBig[0]['ok']) {
								// add big image to video item array
								videoItem.push(dataBig[0]['url']);
							} else {
								videoItem.push(null);
								console.warn('Image ' + dataBig[0]['url'] + ' doesn\'t exist (status code: ' + dataBig['code'] + ').');
							}

							// push video item to conformed videos array
							_this.videosConfirmed.push(videoItem);
						} else {
							console.warn('Image ' + dataMedium[0]['url'] + ' doesn\'t exist (status code: ' + dataMedium['code'] + ').');
						}
					});
				});
			}
		},
		computed: {
			videosConfirmedSorted: function() {
				return this.videosConfirmed.sort(function (a, b) {
					return ((a[0] < b[0]) ? -1 : ((a[0] > b[0]) ? 1 : 0));
				});
			}
		},
		mounted: function () {
			// reinit masonry on resize
			const _this = this;
			$(window).resize(function () {
				_this.SiteInit.masonry($('.s-video').find('.masonry'), false);
			});

			// init photoswipe
			this.SiteInit.photoswipeVideos();

			// console.log(this.videosConfirmedSorted);
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/widgets/Videos.vue